import ThirdPartyLinkageDetails from './ThirdPartyLinkageDetails';

export default ThirdPartyLinkageDetails;
